var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 85,
    viewBox: "0 0 100 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4648_3833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5072 13H28.4373C21.5277 13 16 18.5277 16 25.4373V28.0859H83.9445V25.4373C83.9445 18.5277 78.4169 13 71.5072 13ZM16 34.8804V52.6151C16 59.5247 21.5277 65.0524 28.4373 65.0524H71.5072C78.4169 65.0524 83.9445 59.5247 83.9445 52.6151V34.8804H16ZM48.8207 49.9665H30.7405C28.8979 49.9665 27.2857 48.4694 27.2857 46.5116C27.2857 44.5539 28.7827 43.0568 30.7405 43.0568H48.8207C50.6632 43.0568 52.2755 44.5539 52.2755 46.5116C52.2755 48.4693 50.7784 49.9665 48.8207 49.9665Z",
    fill: "#5926F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4648_3833",
    x: 0.274508,
    y: 0.602654,
    width: 99.3956,
    height: 83.5034,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.32815
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.86275
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.34902 0 0 0 0 0.14902 0 0 0 0 0.941176 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4648_3833"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4648_3833",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardA);
export default __webpack_public_path__ + "static/media/Card_a.f8c8a717177c08be9e8a8f7e2e58a99f.svg";
export { ForwardRef as ReactComponent };